import { FC, useState, useEffect } from 'react';
import { Form } from 'antd';
import { useTrans } from 'base/utils/i18n';
import { IVariant } from 'base/interfaces/product';
import { Button, ButtonProps } from '@base/lib/Button';
import FormEmail from '@base/snippets/FormEmail';
import { postSubscribe, postSubscribeVariant } from 'mod/subscribe/service';
import FormAgree from '@base/snippets/FormAgree';
import { useStoreState, observer } from 'base/store';
import Message from '@base/lib/Message';

type IProps = {
    shownVariant: IVariant;
    onClose: () => void;
    btnProps?: ButtonProps;
};

export const NotifyForm: FC<IProps> = observer(props => {
    const {
        shownVariant,
        onClose,
        btnProps,
    } = props;

    const [loading, setLoading] = useState<boolean>(false);
    const [disabled, setDisabled] = useState<boolean>(true);

    const { t } = useTrans();
    const [form] = Form.useForm();
    const { email } = useStoreState('userStore');

    const onSubmit = async ({ email, subscribeMarketing }: { email: string, subscribeMarketing: boolean }) => {
        setLoading(true);
        try {
            await postSubscribeVariant({
                email,
                variantId: shownVariant.variantId,
                subscribeMarketing
            })
            Message.success(t('web_shop_product_restore_subscription_successful'));
            onClose?.();
        } catch (e) {
        }
        setLoading(false);
    };

    useEffect(() => {
        if (email) {
            form.setFieldsValue({ email });
            setDisabled(false);
        }
    }, [email]);

    return (
        <>
            <div className={'g-prod-title'}>{shownVariant.name || shownVariant.productName}</div>

            <Form
                className={'g-form'}
                form={form}
                layout="vertical"
                onFinish={onSubmit}
                validateTrigger={[]}
                initialValues={{
                    subscribeMarketing: true
                }}
                onValuesChange={(_, allValues) => {
                    setDisabled(!allValues.email);
                    if (!allValues.email) {
                        form.validateFields();
                    }
                }}
            >
                <FormEmail
                    label={false}
                    showLabel={false}
                    inputProps={{
                        className: 'g-email',
                        placeholder: t('web_subscribe_email_placeholder'),
                    }}
                    rules={[
                        {
                            type: 'email',
                            message: t('web_form_email_invalid_tip')
                        },
                    ]}
                />

                <Form.Item noStyle>
                    <Button
                        className="g-btn-submit"
                        htmlType="submit"
                        loading={loading}
                        block
                        disabled={disabled}
                        {...btnProps}
                    >
                        {t('web_shop_product_notify_me')}
                    </Button>
                </Form.Item>

                <FormAgree
                    name={'subscribeMarketing'}
                    label={t('web_shop_product_subscribe_tips')}
                    rules={[]}
                />
            </Form>
        </>
    )
});
